// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from '../../utils/axios';
import utils from '../../utils/utils';
import { dispatch } from '../index';

// ----------------------------------------------------------------------

const BASE_URL = process.env.REACT_APP_BASE_API_URL;
const PATH = 'modules';
const navigateTo = '/modules';

const initialState = {
    error: null,
    modules: [],
    modulesObject: {},
    totalPages: 1,
    loading: false,
    limit: 10,
    currentPage: 1
};

const slice = createSlice({
    name: 'modules',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
            state.loading = false;
        },
        startLoading(state, action) {
            state.loading = true;
        },
        stopLoading(state, action) {
            state.loading = false;
        },
        // GET USERS STYLE 1
        getSuccess(state, action) {
            state.modules = utils.sortAlphatically(action.payload, 'title');
            state.modulesObject = utils.getUniqueObject(action.payload, 'id');
            const total = action.payload.length;
            let pages = Math.floor(total / state.limit);
            const remainder = total % state.limit;
            if (remainder !== 0) {
                pages += 1;
            }
            state.totalPages = pages;
            state.loading = false;
        },
        addSuccess(state, action) {
            state.loading = false;
        },
        editSuccess(state, action) {
            state.loading = false;
        },
        deleteSuccess(state, action) {
            state.loading = false;
            state.modules = state.modules.filter((item) => item.id !== action.payload.id);
        },
        setCurrentPage(state, action) {
            console.log(action.payload);
            state.currentPage = action.payload;
        }
    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function startLoading() {
    return async () => {
        dispatch(slice.actions.startLoading());
    };
}

export function stopLoading() {
    return async () => {
        dispatch(slice.actions.stopLoading());
    };
}

export function getModules() {
    return async () => {
        try {
            const result = await axios.get(`${BASE_URL}/${PATH}`);
            console.log('RES [getModules] ======> ', result.data.data);
            dispatch(slice.actions.getSuccess(result.data.data));
        } catch (error) {
            console.log('ERR [getModules] ======> ', error);
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function addModule(data, navigate) {
    return async () => {
        try {
            const result = await axios.post(`${BASE_URL}/${PATH}`, data);
            console.log('RES [addModule] ======> ', result.data.data);
            dispatch(slice.actions.addSuccess(result.data.data));
            navigate(navigateTo);
        } catch (error) {
            console.log('ERR [addModule] ======> ', error);
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function editModule(id, data, navigate) {
    return async () => {
        const URL = `${BASE_URL}/${PATH}?id=${id}`;
        try {
            const result = await axios.put(URL, data);
            console.log('RES [editModule] ======> ', result.data.data);
            dispatch(slice.actions.editSuccess(result.data.data));
            navigate(navigateTo);
        } catch (error) {
            console.log('ERR [editModule] ======> ', error);
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function deleteModule(id = '') {
    return async () => {
        const URL = `${BASE_URL}/${PATH}?id=${id}`;
        try {
            const result = await axios.delete(URL);
            console.log('RES [deleteModule] =======> ', result);
            dispatch(slice.actions.deleteSuccess(result.data.data));
        } catch (error) {
            console.log('ERR [deleteModule] ======> ', error);
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function setCurrentPage(page) {
    return async () => {
        dispatch(slice.actions.setCurrentPage(page));
    };
}
